import { RootState } from '../store';

import { ITokenPayState } from './token-pay.slice';

export const selectPaymentToken = (state: RootState): ITokenPayState => state.paymentToken;
